import React from "react";
import { Briefcase, X } from "lucide-react";

/**
 * FunctionChip (SOUND-504) — a Job Function rendered in the ticketing chip
 * grammar (`.badge badge-brand` + a small glyph). Read-only by default; pass
 * `onRemove` to make it removable (team-page assignment). `optimistic` dims it
 * while a mutation is in flight.
 */
export default function FunctionChip({ label, onRemove, optimistic = false, className = "" }) {
  return (
    <span className={`badge badge-brand ${optimistic ? "opacity-60" : ""} ${className}`}>
      <Briefcase className="h-3 w-3" />
      {label}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="-mr-0.5 ml-0.5 text-brand/70 transition-colors hover:text-brand"
          aria-label={`Remove ${label}`}
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </span>
  );
}
